import config from '../config/headers';
import { getAPIURL } from '../utils/envGetter';
import http from './http-services';

const apiUrl = getAPIURL();

export async function login(body) {
  config.headers = { 'Content-Type': 'application/json' };
  const { data } = await http.post(`${apiUrl}/auth/login`, body, config);
  return data;
}

export async function compare(body) {
  config.headers = { 'Content-Type': 'application/json' };
  const { data } = await http.post(`${apiUrl}/auth/compare`, body, config);
  return data;
}
